import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, MailIcon, LightbulbIcon, ActivityIcon, BriefcaseIcon, SparklesIcon, ClockIcon, TargetIcon } from 'lucide-react';
export function ProofSection() {
  const changes = [{
    icon: <CalendarIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-389" />,
    text: 'Organizarás tu semana en 10 minutos o menos'
  }, {
    icon: <MailIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-390" />,
    text: 'Redactarás correos y propuestas en la mitad del tiempo'
  }, {
    icon: <LightbulbIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-391" />,
    text: 'Generarás ideas de contenido en bloques rápidos'
  }, {
    icon: <ActivityIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-392" />,
    text: 'Tendrás tu rutina personal, desde ejercicio hasta comidas, optimizada con IA'
  }, {
    icon: <BriefcaseIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-393" />,
    text: 'Automatizarás tareas repetitivas del trabajo que hoy te roban horas'
  }, {
    icon: <SparklesIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-394" />,
    text: 'Crearás presentaciones y reportes profesionales en minutos, no en horas'
  }, {
    icon: <ClockIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-395" />,
    text: 'Tomarás decisiones más rápidas con resúmenes y análisis generados por IA'
  }, {
    icon: <TargetIcon className="w-6 h-6 text-[#D4AF37]" data-id="element-396" />,
    text: 'Definirás metas claras y planes de acción con prompts estratégicos'
  }];
  return <section className="py-24 px-6 bg-[#0A0A0A] relative overflow-hidden border-t border-[#D4AF37]/10" data-id="element-397">
      {/* Background Glows */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-[100px] pointer-events-none" data-id="element-398" />

      <div className="max-w-4xl mx-auto" data-id="element-399">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-400">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#E8E0D0] mb-6" data-id="element-401">
            ¿Qué cambia en{' '}
            <span className="text-[#D4AF37] italic" data-id="element-402">7 días?</span>
          </h2>
          <p className="text-xl text-[#A09880]" data-id="element-403">
            En la primera semana aplicando esta guía:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-404">
          {changes.map((change, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[#111111] border border-[#D4AF37]/20 rounded-2xl p-6 flex items-start gap-4 hover:border-[#D4AF37]/40 transition-colors shadow-[0_0_20px_rgba(0,0,0,0.5)] backdrop-blur-sm" data-id="element-405">
              <div className="bg-[#D4AF37]/10 p-3 rounded-xl shrink-0 border border-[#D4AF37]/20" data-id="element-406">
                {change.icon}
              </div>
              <p className="text-[#E8E0D0] text-lg font-medium pt-1" data-id="element-407">
                {change.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center bg-gradient-to-r from-[#D4AF37]/5 via-[#D4AF37]/15 to-[#D4AF37]/5 border border-[#D4AF37]/30 rounded-2xl p-8 shadow-[0_0_30px_rgba(212,175,55,0.1)]" data-id="element-408">
          <p className="text-xl md:text-2xl font-serif font-bold text-[#E8E0D0]" data-id="element-409">
            Y lo más importante:{' '}
            <span className="text-[#D4AF37] italic" data-id="element-410">
              recuperarás horas valiosas para lo que realmente importa.
            </span>
          </p>
        </motion.div>

        {/* Lifestyle Image */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="mt-12" data-id="element-411">
          <img src="https://cdn.magicpatterns.com/uploads/7xqC58PHxeaDrCLxJx3HYK/heylloyd-image-1775103494430.png" alt="Más tiempo. Menos esfuerzo. Mejor vida." className="w-full max-w-3xl mx-auto rounded-2xl border border-[#D4AF37]/20 shadow-[0_0_40px_rgba(212,175,55,0.1)] object-cover" loading="lazy" data-id="element-412" />
        </motion.div>
      </div>
    </section>;
}